import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=79bd635d&scoped=true&"
import script from "./vHeader.vue?vue&type=script&lang=js&"
export * from "./vHeader.vue?vue&type=script&lang=js&"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=79bd635d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd635d",
  null
  
)

export default component.exports